import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/pages/Home/Home.vue';
import PaySuccess from '@/pages/PaySuccess/PaySuccess.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/paymemt_success',
    name: 'pay_success',
    component: PaySuccess,
  },
];

const router = new VueRouter({
  base: '/web',
  routes,
  mode: 'history'
});

export default router;


